<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import ZxcgcsBrowse from "./ZxcgcsBrowse";
import ZxcgcsEdit from "./ZxcgcsEdit";
import ZxcgcsView from "./ZxcgcsView";
export default {
    name: "Hgryap",
    components: { ZxcgcsBrowse, ZxcgcsEdit, ZxcgcsView },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showView: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "ZxcgcsEdit";
            } else if (this.editProps.showView === true) {
                return "ZxcgcsView";
            } else {
                return "ZxcgcsBrowse";
            }
        }
    }
};
</script>
